"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lseds = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var styled_system_1 = require("styled-system");

var should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));

var types_1 = require("../types");

function createStyled(component) {
  return styled_1["default"](component, {
    shouldForwardProp: should_forward_prop_1["default"]
  })(styled_system_1.compose(styled_system_1.space, styled_system_1.position, styled_system_1.layout, styled_system_1.flexbox, styled_system_1.grid, styled_system_1.background, styled_system_1.color, styled_system_1.border, styled_system_1.shadow, styled_system_1.typography));
}

exports.lseds = createStyled;
types_1.domElements.forEach(function (el) {
  // @ts-ignore
  exports.lseds[el] = exports.lseds(el);
});